import { z } from 'zod';
import { ElementType } from 'react';
import { ErrorIcon, IconSpecificProps, SuccessIcon } from '@ag1/ui';
import {
  NotificationById,
  NotificationConfig,
  NotificationConfigCallbackOptions
} from './Notification.types';

export const successIconComponent: ElementType<IconSpecificProps> = ({ className }) => (
  <SuccessIcon className={className} size={24} />
);
export const errorIconComponent: ElementType<IconSpecificProps> = ({ className }) => (
  <ErrorIcon className={className} size={24} />
);

export const NOTIFICATIONS_ID = z.enum([
  'loadingPortalError',
  'mutationError',
  'mutationSuccess',
  'mutationWarning'
]);

export const TYPE_NOTIFICATION_BY_ID: NotificationById = {
  [NOTIFICATIONS_ID.enum.loadingPortalError]: 'error',
  [NOTIFICATIONS_ID.enum.mutationError]: 'error',
  [NOTIFICATIONS_ID.enum.mutationSuccess]: 'success',
  [NOTIFICATIONS_ID.enum.mutationWarning]: 'warning'
} as const;

export const NOTIFICATIONS: Record<
  z.infer<typeof NOTIFICATIONS_ID>,
  NotificationConfig | ((options: NotificationConfigCallbackOptions) => NotificationConfig | null)
> = {
  loadingPortalError: {
    props: {
      title: 'An error occurred. Please refresh the page'
    }
  },
  mutationError: ({ title, description }) =>
    title
      ? {
          props: {
            title,
            ...(!!description && { description }),
            icon: errorIconComponent
          }
        }
      : {
          props: {
            title: 'Something went wrong. Please try again'
          }
        },
  mutationSuccess: ({ title, description }) =>
    title
      ? {
          props: {
            title,
            ...(!!description && { description }),
            icon: successIconComponent
          }
        }
      : null,
  mutationWarning: ({ title, description }) =>
    title
      ? {
          props: {
            title,
            ...(!!description && { description })
          }
        }
      : null
};
